/* global notyf */
import { Controller } from '@hotwired/stimulus';

import('@material-tailwind/html/scripts/collapse');

export default class extends Controller {
  static targets = [
    'foundationAgreementCheckbox',
    'advisorTermsCheckbox',
    'advisorConsentCheckbox',
    'advisorConsentFull',
    'advisorConsentToggle',
  ];

  checkFoundationAgreement(event) {
    if (!this.foundationAgreementCheckboxTarget.checked) {
      event.preventDefault();

      notyf.open({ type: 'error', message: 'Zaakceptuj umowę, aby aktywować usługę.' });
      return;
    }

    if (this.hasAdvisorTermsCheckboxTarget && !this.advisorTermsCheckboxTarget.checked) {
      event.preventDefault();

      notyf.open({
        type: 'error',
        message: 'Zaakceptuj regulamin usługi doradztwa podatkowego, aby aktywować usługę.',
      });
      return;
    }

    if (this.hasAdvisorConsentCheckboxTarget && !this.advisorConsentCheckboxTarget.checked) {
      event.preventDefault();

      notyf.open({
        type: 'error',
        message: 'Zaakceptuj zgodę na przekazanie danych doradcy podatkowemu, aby aktywować usługę.',
      });
    }
  }

  toggleAdvisorConsent(event) {
    event.preventDefault();

    const expanded = this.advisorConsentFullTarget.classList.toggle('hidden');
    this.advisorConsentToggleTarget.textContent = expanded ? 'Rozwiń' : 'Zwiń';
  }
}
